export default {
  API_URL: process.env.REACT_APP_API_DOMAIN
};
